module.exports = __webpack_public_path__ + "img/nathan_logo.322332b5.png";